import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
const AUTH_API = environment.apiUrl;
@Injectable({
  providedIn: 'root',
})
export class MRSService {

  passedFacility: string = '';
  pageTypeBool: boolean = false;
  standerdPassedFacility: string = '';
  standerdPageTypeBool: boolean = false;

  constructor(private http: HttpClient) { }

  GetMRSFollowUpReport(UID:any,roleName:any, obj: any) {
    return this.http.post(AUTH_API + `/Control/GetPatientFollowUpReport?userId=${UID}&roleName=${roleName}`, obj)
  }

  GetFacilityBySystem(fac_ucd_key_system:any,fac_ucd_key_reginal:any, userId: string, roleName: string) {
    return this.http.get(AUTH_API + `/Control/GetFacilityBySystem?fac_ucd_key_system=${fac_ucd_key_system}&fac_ucd_key_reginal=${fac_ucd_key_reginal}&userId=${userId}&roleName=${roleName}`)
  }
  GetFacilityByRegional(fac_ucd_key_reginal:any,fac_ucd_key_system:any, userId: string, roleName: string) {
    return this.http.get(AUTH_API + `/Control/GetFacilityByRegional?fac_ucd_key_reginal=${fac_ucd_key_reginal}&fac_ucd_key_system=${fac_ucd_key_system}&userId=${userId}&roleName=${roleName}`)
  }
}
